import LogoAdmin from 'atoms/Icons/LogoAdmin';
import LogoText from 'atoms/LogoText';
import Link from 'atoms/NextLink';
import cn from 'classnames';
import React from 'react';
import { useUserAuth } from 'utils/hooks/useUserAuth';

import ImpersonatingUser from './ImpersonatingUser';
import s from './Navigation.module.scss';

interface ILogoNav {
  sideBar: boolean;
  transparent?: boolean;
  dark?: boolean;
  isSticky?: boolean;
}

const LogoNav = ({ sideBar, transparent, dark, isSticky }: ILogoNav) => {
  const authDetails = useUserAuth();

  const getUrl = () => {
    if (authDetails?.isManagement) {
      return '/admin/offerings';
    }
    return '/marketplace';
  };

  return (
    <div className={cn(s.Navigation__logoWrapper, { sideBar }, { transparent, dark, isSticky })}>
      <Link href={getUrl()} key={authDetails?.isAuthenticated ? 'marketplace' : 'homepage'}>
        {authDetails?.isImpersonated ? (
          <span className={s.Navigation__impersonated}>
            <a
              className={s.Navigation__logo}
              aria-label={authDetails?.isAuthenticated ? 'Marketplace' : 'Homepage'}
            >
              <LogoText fill={dark && !isSticky ? 'white' : undefined} />
            </a>
            <ImpersonatingUser email={authDetails?.impersonatingUser} />
          </span>
        ) : authDetails?.isSystem ? (
          <a
            className={s.Navigation__logo}
            aria-label={authDetails?.isAuthenticated ? 'Marketplace' : 'Homepage'}
          >
            <LogoAdmin />
          </a>
        ) : authDetails?.isManagement ? (
          <a
            className={s.Navigation__logo}
            aria-label={authDetails?.isAuthenticated ? 'Marketplace' : 'Homepage'}
          >
            <LogoAdmin />
          </a>
        ) : (
          <a
            className={s.Navigation__logo}
            aria-label={authDetails?.isAuthenticated ? 'Marketplace' : 'Homepage'}
          >
            <LogoText fill={dark && !isSticky ? 'white' : undefined} />
          </a>
        )}
      </Link>
    </div>
  );
};

export default LogoNav;
